export default {
  processor: (session, approve, reject, enabled) => {
    if (enabled && session.loggedIn === true) {
      reject('You are already signed in.');
    }

    approve();
  },
};
